import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import setActiveBulkAction from 'api/administration/participants/SetActiveParticipants'
import { ListOriginEnum } from 'enum/listOrigin.enum'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'

async function addProfiles(
  ids: number[],
  state: boolean,
  search: string,
  allSelected: boolean,
  unselectedRows: number[]
) {
  return await setActiveBulkAction(
    ids,
    state,
    search,
    allSelected,
    unselectedRows
  )
}

function* participantsSetActiveEffectSaga(action: any) {
  try {
    const { origin, ids, state, listConfig, originalListConfig, search, allSelected, unselectedRows } = action.payload
    yield call(addProfiles, ids, state, search, allSelected, unselectedRows)

    if (origin === ListOriginEnum.AddUsersModal) {
      yield put(fromActions.Actions.participantsProfilesList(originalListConfig))
      yield put(fromActions.Actions.participantsInactiveProfilesList(listConfig))
    } else {
      yield put(fromActions.Actions.participantsProfilesList(listConfig))
    }
    const count = ids.length !== 1 ? 'Users' : 'User'
    SuccessToast(I18n.t(`configuration.toastMessages.${state ? `active${count}Success` : `disable${count}Success`}`))
  } catch (error) {
    ErrorToast(I18n.t('configuration.toastMessages.genericError'))

    console.log('error: ', error)
  }
}

export function* participantsSetActiveWatcherSaga() {
  yield takeLatest(fromActions.PARTICIPANTS_SET_ACTIVE, participantsSetActiveEffectSaga)
}
